import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import Menu from './components/Menu';
import CookieBar from './components/CookieBar';
import ScrollTarget from './components/ScrollTarget';
import IncreaseNumbers from './components/IncreaseNumbers';
import AOS from 'aos';

class Fres {
	constructor() {

		Promise.all([Fres.domReady]).then(() => this.init());
		Menu.init();
		ScrollTarget.init();
		IncreaseNumbers.init();
		CookieBar.init();
		AOS.init();

	}

	init() {
		document.dispatchEvent(new Event('bless'));
	}

	static domReady() {
		return new Promise((resolve) =>
			document.addEventListener('DOMContentLoaded', resolve),
		);
	}
}

new Fres();

// jQuery document ready:

// (function($) {
// 	$('body').trigger('bless');
// })(jQuery);
